import React, { useEffect, createElement } from 'react';
import { LandingPage } from './components/LandingPage';
export function App() {
  useEffect(() => {
    // Meta Pixel Integration
    const initPixel = () => {
      // @ts-ignore
      if (window.fbq) return;
      // @ts-ignore
      const n: any = window.fbq = function () {
        // @ts-ignore
        n.callMethod ? n.callMethod.apply(n, arguments) : n.queue.push(arguments);
      };
      // @ts-ignore
      if (!window._fbq) window._fbq = n;
      n.push = n;
      n.loaded = true;
      n.version = '2.0';
      n.queue = [];
      // Safely inject the fbevents script
      const t = document.createElement('script');
      t.async = true;
      t.src = 'https://connect.facebook.net/en_US/fbevents.js';
      document.head.appendChild(t);
      // @ts-ignore
      window.fbq('init', '1206060111307086');
      // @ts-ignore
      window.fbq('track', 'PageView');
    };
    initPixel();
    // AddToCart Tracking for specific buttons
    const handleAddToCart = () => {
      // @ts-ignore
      if (window.fbq) {
        // @ts-ignore
        window.fbq('track', 'AddToCart', {
          content_name: 'Airfryer a la Colombiana',
          currency: 'COP',
          value: 23999
        });
      }
    };
    // We need to wait for the DOM to be fully rendered
    const setupListeners = () => {
      const buyButtons = document.querySelectorAll('#buyNowTop, #buyNowBottom');
      buyButtons.forEach(function (botonCompra) {
        botonCompra.addEventListener('click', handleAddToCart);
      });
      return () => {
        buyButtons.forEach(function (botonCompra) {
          botonCompra.removeEventListener('click', handleAddToCart);
        });
      };
    };
    // Small delay to ensure components are mounted
    const timeoutId = setTimeout(setupListeners, 1000);
    return () => clearTimeout(timeoutId);
  }, []);
  return <>
      <LandingPage data-id="element-0" />
      <noscript data-id="element-1">
        <img height="1" width="1" style={{
        display: 'none'
      }} src="https://www.facebook.com/tr?id=1206060111307086&ev=PageView&noscript=1" data-id="element-2" />
      </noscript>
    </>;
}